import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className="block overflow-hidden pb-1">
        <motion.span
            className={`block ${className}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);
